import g, { stdSerializers as a } from "pino";
import { z as v } from "zod";
const E = ["debug", "info", "warn", "error", "fatal", "audit"], f = v.enum(E), u = !process.env.NODE_ENV || process.env.NODE_ENV === "production", m = process.env.NEXT_PHASE === "phase-production-build", s = () => {
  let e = "info";
  u && (e = "warn"), m && (e = "error");
  const o = process.env.LOG_LEVEL, t = f.safeParse(o);
  return t.success && (e = t.data), e;
}, T = {
  level: s(),
  serializers: {
    err: a.err,
    req: a.req,
    res: a.res
  },
  customLevels: {
    debug: 20,
    info: 30,
    warn: 40,
    error: 50,
    fatal: 60,
    audit: 90
  },
  useOnlyCustomLevels: !0,
  timestamp: !0,
  name: "formbricks"
}, N = () => {
  const e = process.env.NEXT_RUNTIME === "edge", o = process.env.NEXT_RUNTIME === "nodejs" && !!process.env.OTEL_EXPORTER_OTLP_ENDPOINT, t = process.env.OTEL_SERVICE_NAME ?? "formbricks", p = process.env.npm_package_version ?? "0.0.0", d = {
    target: "pino-opentelemetry-transport",
    options: {
      resourceAttributes: {
        "service.name": t,
        "service.version": p,
        "deployment.environment": process.env.ENVIRONMENT ?? process.env.NODE_ENV ?? "development"
      }
    },
    level: s()
  }, i = {
    target: "pino-pretty",
    options: {
      colorize: !0,
      levelFirst: !0,
      translateTime: "SYS:standard",
      ignore: "pid,hostname,ip,requestId",
      customLevels: "trace:10,debug:20,info:30,warn:40,error:50,fatal:60,audit:90",
      useOnlyCustomProps: !0
    },
    level: s()
  };
  if (!u)
    return e ? void 0 : o ? { targets: [i, d] } : { target: i.target, options: i.options };
  if (o)
    return { targets: [{
      target: "pino/file",
      options: { destination: 1 },
      // stdout
      level: s()
    }, d] };
}, c = N(), L = c !== void 0 && "targets" in c, h = {
  ...T,
  transport: c,
  ...!L && {
    formatters: {
      level: (e) => ({ level: e })
    }
  }
}, r = g(h), _ = {
  debug: r.debug.bind(r),
  info: r.info.bind(r),
  audit: r.audit.bind(r),
  warn: r.warn.bind(r),
  error: r.error.bind(r),
  fatal: r.fatal.bind(r)
}, b = {
  ..._,
  withContext: (e) => r.child(e),
  request: (e) => r.child({
    method: e.method,
    url: e.url
  })
}, l = b, n = (e, o) => {
  o && l.error(o, `Error during shutdown (${e})`), l.info({ event: e }, "Process is exiting"), r.flush();
}, I = () => {
  process.env.NEXT_RUNTIME === "nodejs" && (process.on("uncaughtException", (e) => {
    n("uncaughtException", e);
  }), process.on("unhandledRejection", (e) => {
    n("unhandledRejection", e);
  }), process.on("SIGTERM", () => {
    n("SIGTERM");
  }), process.on("SIGINT", () => {
    n("SIGINT");
  }));
};
if (process.env.NEXT_RUNTIME === "nodejs")
  try {
    I();
  } catch (e) {
    l.error(e, "Error attaching process event handlers");
  }
export {
  l as logger
};
